var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10095_9816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16.5C3.5862 16.5 0 12.9138 0 8.5C0 4.0862 3.5862 0.5 8 0.5C12.4138 0.5 16 4.0862 16 8.5C16 12.9138 12.4138 16.5 8 16.5Z",
    fill: "#006FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29612 9.3279C9.40652 9.05204 9.46163 8.77617 9.46163 8.50031C9.46163 7.61755 8.74441 6.95548 7.83407 6.87272C6.62028 6.76238 5.82028 7.28652 5.48924 7.53479C5.35131 7.64514 5.29614 7.86582 5.40648 8.00376C5.51683 8.14169 5.73752 8.16927 5.87545 8.08652C6.1789 7.89342 6.48235 7.83824 6.70304 8.08652C6.92373 8.3072 6.84096 8.63824 6.70304 8.88652L5.35131 11.5623C5.24096 11.8383 5.18579 12.1141 5.18579 12.39C5.18579 13.2727 5.90304 13.9348 6.81338 14.0175C8.02718 14.1279 8.82718 13.6038 9.15825 13.3555C9.29612 13.2451 9.35132 13.0245 9.24101 12.8865C9.13061 12.7486 8.9099 12.721 8.772 12.8038C8.46856 12.9968 8.16511 13.052 7.94441 12.8038C7.72373 12.5831 7.80648 12.252 7.94441 12.0038L9.29612 9.3279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99478 6.01715C9.83273 6.01715 10.512 5.33786 10.512 4.49991C10.512 3.66195 9.83273 2.98267 8.99478 2.98267C8.15683 2.98267 7.47754 3.66195 7.47754 4.49991C7.47754 5.33786 8.15683 6.01715 8.99478 6.01715Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10095_9816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.64ca16883b02ef9933af7bee0fe3f778.svg";
export { ForwardRef as ReactComponent };